<script lang="ts" setup>
import { AppCheckbox } from '@libs/ui';

interface AddFlightsHomeAirportCheckboxProps {
  checked: boolean;
}

const props = defineProps<AddFlightsHomeAirportCheckboxProps>();

interface AddFlightsHomeAirportCheckboxEmits {
  (eventName: 'toggle'): void;
}

const emit = defineEmits<AddFlightsHomeAirportCheckboxEmits>();
</script>

<template>
  <div class="add-flights-hoome-airport-checkbox">
    <AppCheckbox
      class="checkbox"
      :checked="props.checked"
      theme="secondary"
      size="small"
      @change="emit('toggle')"
    >
      <span class="checkbox-label">
        <span class="title">
          {{ $t('modals.add_flights_new.same_homebound_airport') }}
        </span>
        <span class="description">
          {{ $t('modals.add_flights_new.same_airport_you_departed') }}
        </span>
      </span>
    </AppCheckbox>
  </div>
</template>

<style lang="scss" scoped>
.add-flights-hoome-airport-checkbox {
  background-color: var(--color-neutral-10);
  border-radius: var(--border-radius-8);
  padding: var(--spacing-12);

  .checkbox-label {
    display: flex;
    flex-direction: column;

    .title {
      @include font-body-l-bold;

      @include for-less-or-equal-than-899-px {
        display: none;
      }
    }

    .description {
      @include font-body-m-light;
    }
  }
}
</style>
